import { createFileRoute } from '@tanstack/react-router';
import { SelfBookingIndex } from '@/pages/admin-self-booking/SelfBookingIndex';
import { z } from 'zod';

const servicesSearchSchema = z.object({
	serviceId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/bookings/services')({
	component: SelfBookingIndex,
	validateSearch: servicesSearchSchema,
});
